import type { HospiceIdType } from '@app/icare/entities/hospice/schema/Hospice'
import { ContactPersonTable } from '@app/icare/routes/_app/apotheken/-components/ContactPersonTable'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/hospize/$id/contact-persons')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ContactPersonTable ownerId={Route.useParams().id as HospiceIdType} />
}
